import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import {
  createQuestion,
  editQuestion,
} from "../../../api/endpoints/QuestionEndpoints";
import { Question } from "../../../models/Question";

export default function useCreateOrEditQuestion(
  quizId: string,
  questionId: string,
) {
  return useMutation<
    { id: number },
    AxiosError,
    { question: Question; operation: "create" | "edit" }
  >({
    mutationKey: ["create-or-edit-question", quizId, questionId],
    mutationFn: ({ question, operation }) =>
      operation === "create"
        ? createQuestion(quizId, question)
        : editQuestion(quizId, questionId, question),
  });
}
